import React, { useEffect, useState } from "react";
import {
  CustomTablePagination,
  EnhancedSearchTableToolbar
} from "../../Utils/Tables/CustomTable";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as snackbarActions from "../../../actions/snackbarActions";
import MainSnackbar from "../../Utils/Snackbar/SmsSnackbar";
import { Container } from "../../Utils/styledComponents";
import axios from "axios";
import { config } from "../../../Helpers/env";
import { logoutErrorMessage } from "../../../Helpers/ErrorMessages";
import { LoadingGif } from "../../Utils/Loader";
import {
  CustomTableCell,
  MuiPaper,
  StickyHeadTable
} from "../../Utils/Tables/StickyHeaderTable";
import PageTitle from "../../Utils/smsTitle";
import { SubHeader } from "../../../Containers/SubHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClipboardList,
  faFileExcel,
  faFilePdf
} from "@fortawesome/free-solid-svg-icons";
import { CustomSelect } from "../../Utils/FormInputs/SelectInput";
import { BackButton } from "../../Utils/Buttons/DataExportationButton";
import {
  useExcelReports,
  usePdfDownload
} from "../../Utils/ReusableComponents/useExcelExport";
import CustomDialog from "../../Utils/Dialogs/CustomDialog";
import { useDebounce } from "../../Lab/useDebounce";
import { ExcelConsumptionData } from "./ExcelConsumptionData";

const headData = [
  { id: "count", numeric: false, disablePadding: false, label: "Sl" },
  { id: "product_name", numeric: false, disablePadding: false, label: "Product" },
  { id: "quantity_in", numeric: false, disablePadding: false, label: "Quantity In" },
  { id: "quantity_out", numeric: false, disablePadding: false, label: "Quantity Out" },
  { id: "reorder_level", numeric: false, disablePadding: false, label: "Reorder Level" },
  { id: "available_stock", numeric: false, disablePadding: false, label: "Available Stock" }
];

const OutofStockReport = ({ actions, snackbars }) => {
  const departments = [
    { value: "1", label: "Store" },
    { value: "2", label: "Pharmacy" },
    { value: "3", label: "Laboratory" }
  ];

  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState({
    stockList: [],
    loading: "idle",
    total: 0
  });
  const [activePage, setActivePage] = useState(1);
  const [department, setDepartment] = useState({ value: "1", label: "Store" });
  const [openDialog, setOpenDialog] = useState(false);
  const [debouncedValue] = useDebounce(searchValue, 500);

  const { loading, total, stockList } = data;

  useEffect(() => {
    setActivePage(1);
    setPage(0);
  }, [department]);

  useEffect(() => {
    setData((prev) => ({ ...prev, loading: "pending" }));
    axios
      .post(
        `${config.smsUrl}/creport/out_of_stock/${activePage}`,
        null,
        {
          params: {
            search: debouncedValue || undefined,
            department_id: department?.value,
            per_page: rowsPerPage
          }
        }
      )
      .then((res) => {
        const dt = res.data || {};
        setData({
          loading: "success",
          stockList: dt.out_of_stock || [],
          total: dt.total_count || 0
        });
      })
      .catch((err) => {
        setData((prev) => ({ ...prev, loading: "error" }));
        logoutErrorMessage(err, null, actions);
      });
  }, [department, debouncedValue, activePage, rowsPerPage]);

  const handleSearch = (event) => {
    setSearchValue(event.target.value);
    setActivePage(1);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setActivePage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setActivePage(1);
  };

  const closeSnackbar = () => {
    actions.snackbarActions.hideSnackbar();
  };

  const { openBar, type, message } = snackbars;
  const isLoading = loading === "pending";
  const isSuccess = loading === "success";
  const isError = loading === "error";

  const pagination = (
    <CustomTablePagination
      colSpan={3}
      activePage={activePage}
      page={page}
      rowsPerPage={rowsPerPage}
      count={total}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      isTotalCount
    />
  );

  const search_bar = (
    <EnhancedSearchTableToolbar
      term={searchValue}
      handler={handleSearch}
      placeholder="Search product..."
    />
  );

  const file_name = `${department?.label} Out of Stock Report`;

  const department_name = {
    1: "store",
    2: "pharmacy",
    3: "lab"
  };

  const excelObj = {
    file_name,
    params: {
      department: department_name[department?.value],
      download_type: 2
    },
    url: "creport/out_of_stock_pdf"
  };

  const pdfObj = {
    file_name,
    params: {
      department: department_name[department?.value],
      download_type: 1
    },
    url: "creport/out_of_stock_pdf"
  };

  const { exportExcel, isLoading: isLoadingExcel } = useExcelReports(
    actions,
    excelObj
  );
  const { exportPdf, isLoading: isLoadingPdf } = usePdfDownload(
    actions,
    pdfObj
  );

  return (
    <div data-testid="out-of-stock-stock-report">
      <PageTitle title="Out of Stock Report" />
      <SubHeader title="Reports" subTitle="Out of Stock Report">
        <FontAwesomeIcon icon={faClipboardList} />
      </SubHeader>

      <CustomDialog
        open={openDialog}
        handleClose={() => setOpenDialog(false)}
        title="Export consumption excel data"
      >
        <ExcelConsumptionData {...{ actions, setOpenDialog }} />
      </CustomDialog>

      <Container className="mt-1">
        <MainSnackbar
          variant={type}
          open={openBar}
          message={message}
          handleCloseBar={closeSnackbar}
        />

        {/* ===== TOP SECTION ===== */}
        <div style={{ padding: "8px 0 0 0" }}>
          {/* Back + Export buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              marginBottom: "12px",
              gap: "8px"
            }}
          >
            <BackButton to="/reports/generalreports" text="Reports" />

            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
              <button
                type="button"
                onClick={exportExcel}
                disabled={isLoadingExcel}
                className="btn btn-sm text-white"
                style={{
                  backgroundColor: "#389081",
                  borderColor: "#389081",
                  height: "32px",
                  padding: "0 14px",
                  fontSize: "13px",
                  borderRadius: "6px"
                }}
              >
                <FontAwesomeIcon icon={faFileExcel} className="me-1" />
                {isLoadingExcel ? "Exporting..." : "Excel"}
              </button>

              <button
                type="button"
                onClick={exportPdf}
                disabled={isLoadingPdf}
                className="btn btn-sm text-white"
                style={{
                  backgroundColor: "#389081",
                  borderColor: "#389081",
                  height: "32px",
                  padding: "0 14px",
                  fontSize: "13px",
                  borderRadius: "6px"
                }}
              >
                <FontAwesomeIcon icon={faFilePdf} className="me-1" />
                {isLoadingPdf ? "Exporting..." : "PDF"}
              </button>

              <button
                type="button"
                onClick={() => setOpenDialog(true)}
                disabled={isLoadingExcel || isLoadingPdf}
                className="btn btn-sm text-white"
                style={{
                  backgroundColor: "#389081",
                  borderColor: "#389081",
                  height: "32px",
                  padding: "0 14px",
                  fontSize: "13px",
                  borderRadius: "6px"
                }}
              >
                Consumption Excel Data
              </button>
            </div>
          </div>

          {/* Department filter – tight */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "10px",
              marginBottom: "14px"
            }}
          >
            <div style={{ minWidth: "180px" }}>
              <CustomSelect
                value={department}
                onChange={(value) => {
                  setDepartment(value);
                  setActivePage(1);
                  setPage(0);
                  setRowsPerPage(10);
                }}
                options={departments}
              />
            </div>
          </div>
        </div>

        {/* TABLE */}
        <MuiPaper style={{ borderRadius: "10px", overflow: "hidden" }}>
          {search_bar}
          <StickyHeadTable
            {...{
              width: "100%",
              data: stockList,
              columns: headData.filter((item) => Boolean(item)),
              pagination
            }}
          >
            {isLoading ? (
              <TableRow>
                <TableCell align="center" colSpan={headData.length}>
                  <LoadingGif />
                </TableCell>
              </TableRow>
            ) : null}

            {isSuccess ? (
              stockList.length > 0 ? (
                stockList.slice(0, rowsPerPage).map((row, index) => {
                  const count =
                    (activePage - 1) * rowsPerPage + index + 1;
                  return (
                    <TableRow tabIndex={-1} key={index} hover>
                      {headData.map((col) =>
                        col.id === "count" ? (
                          <CustomTableCell key={col.id}>
                            {count}
                          </CustomTableCell>
                        ) : (
                          <CustomTableCell key={col.id}>
                            {row[col.id] ?? "-"}
                          </CustomTableCell>
                        )
                      )}
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell align="center" colSpan={headData.length}>
                    No records found
                  </TableCell>
                </TableRow>
              )
            ) : null}

            {isError ? (
              <TableRow>
                <TableCell align="center" colSpan={headData.length}>
                  The server did not return a valid response
                </TableCell>
              </TableRow>
            ) : null}
          </StickyHeadTable>
        </MuiPaper>
      </Container>
    </div>
  );
};

function mapStateToProps(state) {
  return { snackbars: state.snackbar };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      snackbarActions: bindActionCreators(snackbarActions, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OutofStockReport);